import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class TypeContratService {

    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/type-contrat/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/type-contrat/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/type-contrat/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/type-contrat/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/type-contrat/delete/${id}`), callback);
   

}